import { ServiceModelCrudController, ApiCrudObjectControllerBindings } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Provides UI for modifying service model.
 * @example
 * ```html
 * <salaxy-service-model-details></salaxy-service-model-details>
 * ```
 */

export class ServiceModelDetails extends ComponentBase {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = new ApiCrudObjectControllerBindings();

  /** Uses the AccountController */
  public controller = ServiceModelCrudController;

  /** Default template is the view  */
  public defaultTemplate = "salaxy-components/settings/ServiceModelDetails.html";

}
